import {
  Instagram, Twitter, Facebook, Youtube, Linkedin, Film, Music2, Video, AtSign,
  Link as LinkIcon,
} from "lucide-react";

export const SOCIAL_PLATFORMS = [
  { key: "instagram", label: "Instagram", placeholder: "@handle or link", icon: Instagram },
  { key: "x", label: "X (Twitter)", placeholder: "@handle or link", icon: Twitter },
  { key: "facebook", label: "Facebook", placeholder: "facebook.com/…", icon: Facebook },
  { key: "youtube", label: "YouTube", placeholder: "youtube.com/@…", icon: Youtube },
  { key: "imdb", label: "IMDb", placeholder: "imdb.com/name/…", icon: Film },
  { key: "linkedin", label: "LinkedIn", placeholder: "linkedin.com/in/…", icon: Linkedin },
  { key: "tiktok", label: "TikTok", placeholder: "@handle or link", icon: Music2 },
  { key: "vimeo", label: "Vimeo", placeholder: "vimeo.com/…", icon: Video },
  { key: "threads", label: "Threads", placeholder: "@handle or link", icon: AtSign },
  { key: "other", label: "Other", placeholder: "Any other profile link", icon: LinkIcon },
];

export const socialHref = (key, value) => {
  const v = (value || "").trim();
  if (!v) return null;
  if (/^https?:\/\//i.test(v)) return v;
  const handle = v.replace(/^@/, "");
  const base = {
    instagram: "https://instagram.com/",
    x: "https://x.com/",
    facebook: "https://facebook.com/",
    youtube: "https://youtube.com/@",
    tiktok: "https://tiktok.com/@",
    threads: "https://threads.net/@",
    linkedin: "https://linkedin.com/in/",
    vimeo: "https://vimeo.com/",
    imdb: "https://imdb.com/name/",
  }[key];
  return base ? base + handle : `https://${v}`;
};

export const externalHref = (value) => {
  const v = (value || "").trim();
  if (!v) return null;
  return /^https?:\/\//i.test(v) ? v : `https://${v}`;
};
